export default {
  index: [
    {
      path: '/zkyj',
      component: resolve => require(['./zkcommissionIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkpromoter_commission_config/_router.js